import { setSocketPrinterDesktopSessions } from '../../redux/action/socket'
import { setPrintersUpdateTrigger } from '../../redux/action/printer'
import { setAppModal, setAppModalData } from '../../redux/action/system'
import { setStripeReportPrintMessageData } from '../../redux/action/report'
import { handleSavePdfResponse, handleSavePdfFailed } from '../../redux/thunk/report/savePdf'
import { upsertPrintTask, upsertPrintTasks } from '@liefersoft/pos-ui-core'
import { logger } from '../../logger/logger'

export const processPrinterMessageThunk = (message) => (dispatch, getState) => {
	const state = getState()
	switch (message?.type) {
		case 'printer.DESKTOP_SESSION_LIST_PROVIDED_EVENT':
			dispatch(setSocketPrinterDesktopSessions(message.data))
			break
		case 'printer.PRINTERS_UPDATED_EVENT':
			if (window.location.href.includes('/settings/printer')) {
				dispatch(setPrintersUpdateTrigger(state.printer.printersUpdateTrigger + 1))
			}
			break
		case 'printer.FRONTEND_PRINT_REQUESTED_EVENT':
			const stripeReportToPrint = state.reportStore.stripeReportToPrint
			if (window.location.href.includes('/report/monthly') && stripeReportToPrint) {
				dispatch(setStripeReportPrintMessageData(message.data))
			} else {
				dispatch(setAppModal({ printMessageModalShow: true }))
				const modalData = state.system.modalData?.printMessageModalData
				dispatch(setAppModalData({ printMessageModalData: [...modalData, message.data] }))
			}
			break
		case 'printer.PRINT_TASKS_CREATED_EVENT':
		case 'printer.PRINT_TASKS_CLAIMED_EVENT':
			dispatch(upsertPrintTasks(message.data.tasks))
			break
		case 'printer.PRINT_TASK_UPDATED_EVENT':
			dispatch(upsertPrintTask(message.data))
			break
		case 'printer.MONTHLY_REPORT_PDF_SAVE_RESPONSE_EVENT':
			logger.info('[SavePdf] ws-reply', { traceId: message.data.traceId, filename: message.data.filename, stage: 'ws-reply' })
			handleSavePdfResponse(message.data.traceId, message.data.html, message.data.filename)
			break
		case 'printer.MONTHLY_REPORT_PDF_SAVE_FAILED_EVENT':
			logger.warn('[SavePdf] ws-failed', { traceId: message.data.traceId, reason: message.data.reason, stage: 'ws-failed' })
			handleSavePdfFailed(message.data.traceId, message.data.reason)
			break
		default:
			logger.error('Unknown printer message type: ', JSON.stringify(message))
			break
	}
}

